import { render, staticRenderFns } from "./modal-transfer-primary-user.vue?vue&type=template&id=12e92d9a&scoped=true&lang=pug"
import script from "./modal-transfer-primary-user.js?vue&type=script&lang=js&external"
export * from "./modal-transfer-primary-user.js?vue&type=script&lang=js&external"
import style0 from "./modal-transfer-primary-user.vue?vue&type=style&index=0&id=12e92d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e92d9a",
  null
  
)

export default component.exports